module.exports = __webpack_public_path__ + "images/pages/injection-guidelines/percutaneous-step-2.png";